// UI Framework
import { TableCell } from "@mui/material";
import { Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
// Common Components
import { Loading } from "src/Components";
// Hooks
import { useState } from "react";
// Services
import {
  deletePortfolioGroup,
  upsertPortfolioGroup,
} from "src/Requests/portfolioGroups";
// Utilities
import { packetErrorHandler } from "src/Utils/requestUtils";
// Types
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { IPortfolioGroupTableReport } from "src/Interfaces/portfolioGroups";

const AdditionalHeader: React.FC = () => (
  <>
    <TableCell />
    <TableCell />
  </>
);

export const getPortfolioGroupAdditional = (
  onEdit: (row: IPortfolioGroupTableReport) => void,
  onSuccess?: () => void,
): IAdditional<IPortfolioGroupTableReport> => {
  const AdditionalCol: React.FC<{
    row: IPortfolioGroupTableReport;
    onAction: () => void;
  }> = ({ row, onAction }) => {
    const [loading, setLoading] = useState(false);

    const deleteHandler = () => {
      setLoading(true);
      deletePortfolioGroup(row.id)
        .then((resp) => {
          if (resp.data) {
            toast.success(resp.msg);
            onAction();
            onSuccess?.();
          } else toast.error(resp.msg);
        })
        .catch(packetErrorHandler)
        .finally(() => setLoading(false));
    };

    return (
      <>
        <TableCell className="!w-12">
          <div
            className="hover:bg-slate-300 transition-all rounded p-1"
            onClick={() => onEdit(row)}
          >
            <Edit className="text-sky-700 cursor-pointer" />
          </div>
        </TableCell>
        <TableCell className="!w-12">
          <div
            onClick={deleteHandler}
            className="hover:bg-red-100 transition-all rounded p-1"
          >
            {loading ? (
              <Loading size={16} className="!text-white" />
            ) : (
              <DeleteIcon className="text-red-700 cursor-pointer" />
            )}
          </div>
        </TableCell>
      </>
    );
  };

  return {
    getHeader: AdditionalHeader,
    getRow: AdditionalCol,
  };
};
